import { RedirectRoute } from 'types'
import { CardType, VirtualEventRole } from 'types/card'
import { VirtualEventTaskType } from 'types/event'
import assessmentPlatformRoutes from 'modules/AssessmentPlatform/routes'
import { AccountTypes } from 'modules/Auth/types'
import dashboardRoutes from 'modules/Dashboard/routes'
import digitalDeliveryRoutes from 'modules/DigitalDelivery/routes'
import homeRoutes from 'modules/Home/routing/routes'
import { NotificationType, EventRoles } from 'modules/Notifications/types'
import profileRoutes from 'modules/Profile/routing/routes'
import searchRoutes from 'modules/Search/routing/routes'
import aproDetailsRoutes from 'modules/activityDetails/AproDetails/routing/routes'
import certificateDetailsRoutes from 'modules/activityDetails/CertificateDetails/routing/routes'
import cesCstDetailsRoutes from 'modules/activityDetails/CesCstDetails/routing/routes'
import cesDetailedDetailsRoutes from 'modules/activityDetails/CesDetailedDetails/routing/routes'
import cesStcwDetailsRoutes from 'modules/activityDetails/CesStcwDetails/routing/routes'
import companyNoticeDetailsRoutes from 'modules/activityDetails/CompanyNoticeDetails/routing/routes'
import companySpecificTrainingDetailsRoutes from 'modules/activityDetails/CompanySpecificTrainingDetails/routing/routes'
import courseDetailsRoutes from 'modules/activityDetails/CourseDetails/routing/routes'
import distanceCourseDetailsRoutes from 'modules/activityDetails/DistanceCourseDetails/routing/routes'
import educationDetailsRoutes from 'modules/activityDetails/EducationDetails/routing/routes'
import elearningDetailsRoutes from 'modules/activityDetails/ElearningDetails/routing/routes'
import marlinsEnglishTestDetailsRoutes from 'modules/activityDetails/MarlinsEnglishTestDetails/routing/routes'
import onboardAssessmentDetailsRoutes from 'modules/activityDetails/OnboardAssessmentDetails/routing/routes'
import pproDetailsRoutes from 'modules/activityDetails/PproDetails/routing/routes'
import quickGuideDetailsRoutes from 'modules/activityDetails/QuickGuideDetails/routing/routes'
import rapidElearningDetailsRoutes from 'modules/activityDetails/RapidElearningDetails/routing/routes'
import selfAssessmentDetailsRoutes from 'modules/activityDetails/SelfAssessmentDetails/routing/routes'
import serviceRecordDetailsRoutes from 'modules/activityDetails/ServiceRecordDetails/routing/routes'
import surveyDetailsRoutes from 'modules/activityDetails/SurveyDetails/routing/routes'
import videoDetailsRoutes from 'modules/activityDetails/VideoDetails/routing/routes'
import programBuilderRoutes from 'modules/programBuilder/routes'
import requirementsCompletionDetailsRoutes from 'modules/requirements/RequirementCompletionDetails/routing/routes'
import requirementsRoutes from 'modules/requirements/Requirements/routing/routes'
import { SimulatorTrainingType } from 'modules/simulatorTrainings/common/types'
import simulatorTrainingInstructorILSimulatorListRoutes from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/routing/routes'
import simulatorTrainingInstructorILTrainingDetailsRoutes from 'modules/simulatorTrainings/instructor/instructorLed/TrainingDetails/routing/routes'
import simulatorTrainingInstructorSLExerciseListRoutes from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/routing/routes'
import simulatorTrainingInstructorSlTrainingDetailsRoutes from 'modules/simulatorTrainings/instructor/studentLed/TrainingDetails/routing/routes'
import simulatorTrainingStudentILTrainingDetailsRoutes from 'modules/simulatorTrainings/student/instructorLed/TrainingDetails/routing/routes'
import simulatorTrainingStudentSlTrainingDetailsRoutes from 'modules/simulatorTrainings/student/studentLed/TrainingDetails/routing/routes'
import distanceCoursesRoutes from 'modules/trainingLibrary/DistanceCourses/routing/routes'
import elearningRoutes from 'modules/trainingLibrary/Elearning/routing/routes'
import rapidElearningRoutes from 'modules/trainingLibrary/RapidElearning/routing/routes'
import surveysRoutes from 'modules/trainingLibrary/Surveys/routing/routes'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'
import virtualClassrooManagerEventCreatorRoutes from 'modules/virtualClassrooms/manager/EventCreator/routing/routes'
import virtualClassrooManagerEventListRoutes from 'modules/virtualClassrooms/manager/EventList/routing/routes'
import virtualClassroomStudentEventDetailsRoutes from 'modules/virtualClassrooms/student/EventDetails/routing/routes'
import virtualClassroomStudentEventsRoutes from 'modules/virtualClassrooms/student/Events/routing/routes'
import virtualClassroomStudentParticipantScheduleDetailsRoutes from 'modules/virtualClassrooms/student/ParticipantScheduleDetails/routing/routes'
import virtualClassroomStudentPresenterScheduleDetailsRoutes from 'modules/virtualClassrooms/student/PresenterScheduleDetails/routing/routes'

class NavigationUtils {
  getActivityDetailsRoute = (activityType: CardType): string => {
    switch (activityType) {
      case CardType.UserRequirement:
        return requirementsCompletionDetailsRoutes.root
      case CardType.TrainingModule:
        return elearningDetailsRoutes.root
      case CardType.TrainingVideo:
        return videoDetailsRoutes.root
      case CardType.PocketGuide:
        return quickGuideDetailsRoutes.root
      case CardType.DistanceCourse:
        return distanceCourseDetailsRoutes.root
      case CardType.Rapid:
        return rapidElearningDetailsRoutes.root
      case CardType.Survey:
        return surveyDetailsRoutes.root
      case CardType.Certificate:
        return certificateDetailsRoutes.root
      case CardType.CompanyNotice:
        return companyNoticeDetailsRoutes.root
      case CardType.Education:
        return educationDetailsRoutes.root
      case CardType.ServiceRecord:
        return serviceRecordDetailsRoutes.root
      case CardType.Ppro:
        return pproDetailsRoutes.root
      case CardType.CesDetailed:
        return cesDetailedDetailsRoutes.root
      case CardType.Cst:
        return companySpecificTrainingDetailsRoutes.root
      case CardType.Course:
        return courseDetailsRoutes.root
      case CardType.OnboardAssessment:
        return onboardAssessmentDetailsRoutes.root
      case CardType.SelfAssessment:
        return selfAssessmentDetailsRoutes.root
      case CardType.CesStcw:
        return cesStcwDetailsRoutes.root
      case CardType.CesCompanySpecific:
        return cesCstDetailsRoutes.root
      case CardType.Apro:
        return aproDetailsRoutes.root
      case CardType.ElearningCategory:
        return elearningRoutes.category
      case CardType.RequirementsGroup:
        return requirementsRoutes.group
      case CardType.VirtualEventsCategory:
        return virtualClassroomStudentEventsRoutes.category
      case CardType.VirtualEventsEvent:
        return virtualClassroomStudentEventDetailsRoutes.root
      case CardType.MarlinsEnglishTest:
        return marlinsEnglishTestDetailsRoutes.root
      default:
        return ''
    }
  }

  getMyEventsScheduleDetailsRoute = (role: VirtualEventRole): string => {
    switch (role) {
      case VirtualEventRole.Presenter:
        return virtualClassroomStudentPresenterScheduleDetailsRoutes.root
      case VirtualEventRole.Participant:
        return virtualClassroomStudentParticipantScheduleDetailsRoutes.root
      default:
        return ''
    }
  }

  getEventNotificationScheduleDetailsRoute = (role: EventRoles): string => {
    switch (role) {
      case EventRoles.Presenter:
        return virtualClassroomStudentPresenterScheduleDetailsRoutes.root
      case EventRoles.Listener:
        return virtualClassroomStudentParticipantScheduleDetailsRoutes.root
      default:
        return ''
    }
  }

  getSimulatorTrainingDetailsRoute = (role: AccountTypes, type: SimulatorTrainingType): string => {
    switch (role) {
      case AccountTypes.User:
        return this.getSimulatorTrainingStudentDetailsRoute(type)
      case AccountTypes.SpecialUser:
        return this.getSimulatorTrainingInstructorDetailsRoute(type)
      default:
        return ''
    }
  }

  getSimulatorTrainingStudentDetailsRoute = (type: SimulatorTrainingType): string => {
    switch (type) {
      case SimulatorTrainingType.Instructor:
        return simulatorTrainingStudentILTrainingDetailsRoutes.root
      case SimulatorTrainingType.Student:
        return simulatorTrainingStudentSlTrainingDetailsRoutes.root
      default:
        return ''
    }
  }

  getSimulatorTrainingInstructorDetailsRoute = (type: SimulatorTrainingType): string => {
    switch (type) {
      case SimulatorTrainingType.Instructor:
        return simulatorTrainingInstructorILTrainingDetailsRoutes.root
      case SimulatorTrainingType.Student:
        return simulatorTrainingInstructorSlTrainingDetailsRoutes.root
      default:
        return ''
    }
  }

  getActivityTypeRoute = (activityType: ActivityType): string => {
    switch (activityType) {
      case ActivityType.TrainingModules:
        return elearningRoutes.root
      case ActivityType.DistanceCourses:
        return distanceCoursesRoutes.root
      case ActivityType.RapidElearning:
        return rapidElearningRoutes.root
      case ActivityType.Surveys:
        return surveysRoutes.root
      default:
        return ''
    }
  }

  getEventTypeRoute = (activityType: VirtualEventTaskType): string => {
    switch (activityType) {
      case VirtualEventTaskType.Elearning:
        return elearningDetailsRoutes.root
      case VirtualEventTaskType.RapidElearning:
        return rapidElearningDetailsRoutes.root
      case VirtualEventTaskType.Survey:
        return surveyDetailsRoutes.root
      case VirtualEventTaskType.CesDetailed:
        return cesDetailedDetailsRoutes.root
      case VirtualEventTaskType.CesStcw:
        return cesStcwDetailsRoutes.root
      case VirtualEventTaskType.CesCST:
        return cesCstDetailsRoutes.root
      default:
        return ''
    }
  }

  getHighlightedNotificationDetailsRoute(activityType: NotificationType) {
    switch (activityType) {
      case NotificationType.CompanyNotice:
        return companyNoticeDetailsRoutes.root
      case NotificationType.Survey:
        return surveyDetailsRoutes.root
      default:
        return ''
    }
  }

  getRedirectRoute(route?: RedirectRoute) {
    switch (route) {
      case RedirectRoute.Search:
        return searchRoutes.root
      case RedirectRoute.Profile:
        return profileRoutes.root
      case RedirectRoute.Library:
        return trainingLibraryRoutes.root
      case RedirectRoute.Requirements:
        return requirementsRoutes.root
      case RedirectRoute.MyEvents:
        return virtualClassroomStudentEventsRoutes.my
      case RedirectRoute.EventLibrary:
        return virtualClassroomStudentEventsRoutes.library
      case RedirectRoute.InstructorLed:
        return simulatorTrainingInstructorILSimulatorListRoutes.root
      case RedirectRoute.StudentLed:
        return simulatorTrainingInstructorSLExerciseListRoutes.root
      case RedirectRoute.VirtualClassroomCreateEvent:
        return virtualClassrooManagerEventCreatorRoutes.root
      case RedirectRoute.VirtualClassroomManageEvents:
        return virtualClassrooManagerEventListRoutes.root
      case RedirectRoute.ProgramBuilder:
        return programBuilderRoutes.root
      case RedirectRoute.DigitalDelivery:
        return digitalDeliveryRoutes.root
      case RedirectRoute.Dashboard:
        return dashboardRoutes.root
      case RedirectRoute.AssessmentPlatform:
        return assessmentPlatformRoutes.root
      case RedirectRoute.Home:
      default:
        return homeRoutes.root
    }
  }
}

export default new NavigationUtils()
